import clsx from 'clsx'
import { observer } from 'mobx-react'
import * as React from 'react'

import type { DefaultProps } from '@/types'

import S from './Group.style'

type Props = {
  GroupNode: React.ReactNode
  children?: React.ReactNode
  isOpen?: boolean
} & DefaultProps

const Group = ({ GroupNode, children, isOpen }: Props) => {
  return (
    <>
      {GroupNode}
      <div className={clsx(isOpen && 'is-open')} css={S.default}>
        {children}
      </div>
    </>
  )
}

export default observer(Group)
